import React, { useCallback } from 'react';
import c from 'classnames';
import { Field, FieldArray } from 'formik';
import { useTranslation } from 'react-i18next';

import WebformTextField from '@uncinc/react-drupal-core/dist/Components/Webform/WebformTextField';

import GenericFormElement from '@uncinc/uncinc-react-kitchen-sink/dist/components/Form/GenericFormElement';

import Button from '../../Button';

const WebformTextFieldWithDelta = (props) => {
  const { entity, type } = props;
  const { t } = useTranslation();
  const title = entity.get('#title');
  const required = entity.get('#required');
  const description = entity.get('#description');
  const placeholder = entity.get('#placeholder');
  const requiredError = entity.get('#required_error');
  const key = entity.get('#webform_key');
  const isMultiple = entity.get('#webform_multiple', false);
  const maxLength = entity.get('#maxlength', 255);
  const maxLengthError = entity.get('#maxlength_error');
  const wrapperClassNames = c('WebformTextField', entity.getIn(['#wrapper_attributes', 'class', 0], ''));
  const elementClassNames = entity.getIn(['#attributes', 'class', 0], '');
  const parentValue = props.values[key];

  React.useEffect(() => {
    if (!isMultiple) {
      return;
    }

    if (!Array.isArray(props.values[key]) || props.values[key].length === 0) {
      props.setFieldValue(key, ['']);
    }
  }, []);

  const validation = useCallback((value) => {
    let error;
    if (Array.isArray(value)) {
      const nonEmptyValues = value.filter((x) => !!x && x !== '');
      if (nonEmptyValues.length < 1 && required) {
        error = requiredError || t(['webform.components.text_field.required', 'webform.required', 'webform_required']);
      }
      value.forEach((x) => {
        if (x?.length > maxLength) {
          error = maxLengthError || t(['webform.components.text_field.max_length', 'webform.max_length', 'webform_max_length'], { max: maxLength });
        }
      });
    } else if (required && !value) {
      error = requiredError || t(['webform.components.text_field.required', 'webform.required', 'webform_required']);
    }
    else if (value?.length > maxLength) {
      error = maxLengthError || t(['webform.components.text_field.max_length', 'webform.max_length', 'webform_max_length'], { max: maxLength });
    }
    return error;
  }, [required, requiredError, maxLength, maxLengthError]);

  if (isMultiple && Array.isArray(parentValue) && parentValue.length > 0) {
    return (
      <FieldArray
        name={key}
        render={({ form, push }) => (
          <div className={wrapperClassNames}>
            {parentValue.map((item, index) => {
              const childKey = `${key}.${index}`;
              const isTouched = form.touched[key]?.[index];
              const error = form.errors[key]?.[index];

              return (
                <GenericFormElement
                  key={childKey}
                  className="TextField"
                  title={index === 0 && title}
                  required={required}
                  description={description}
                  fieldName={childKey}
                  touched={isTouched}
                  error={error}
                >
                  <Field
                    className={c(elementClassNames, { 'error': error && isTouched })}
                    id={childKey}
                    name={childKey}
                    type={type}
                    placeholder={placeholder}
                    validate={validation}
                  />
                </GenericFormElement>
              );
            })}

            <Button onClick={() => push('')}>
              {t('webform.components.text_field_with_delta.add_another')}
            </Button>
          </div>
        )}
      />
    );
  }

  return <WebformTextField {...props} />;
};

export default WebformTextFieldWithDelta;
